import { render, staticRenderFns } from "./AppVersionManager.vue?vue&type=template&id=18d4e74d&scoped=true"
import script from "./AppVersionManager.vue?vue&type=script&lang=js"
export * from "./AppVersionManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4e74d",
  null
  
)

export default component.exports